import { useLocation, useNavigate } from "react-router-dom";

import { Paths } from "@/core/constants/paths";
import { usePageHeaderTabs } from "@/ds";
import { usePermissoes } from "@/modules/permissoes";
import {
  FINANCEIRO_ABAS,
  FINANCEIRO_CONFIGURACOES_SUBABAS,
  FINANCEIRO_MOBILE_QUERY,
  FINANCEIRO_SUBABAS_LABEL,
  FINANCEIRO_TABS_LABEL,
  FINANCEIRO_TITLE,
} from "./financeiro-configuracoes.constants";
import type {
  FinanceiroConfiguracoesConteudo,
  FinanceiroConfiguracoesViewModel,
} from "./types-financeiro-configuracoes";

const dentroDe = (caminho: string, base: string) =>
  caminho === base || caminho.startsWith(`${base}/`);

export function useFinanceiroConfiguracoes(): FinanceiroConfiguracoesViewModel {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { status, hasPermissao } = usePermissoes();

  const abas = FINANCEIRO_ABAS.filter((aba) => !aba.claim || hasPermissao(aba.claim)).map(
    ({ label, to }) => ({ label, to }),
  );
  const todasSubAbas = FINANCEIRO_CONFIGURACOES_SUBABAS.filter((subAba) =>
    hasPermissao(subAba.claim),
  ).map(({ label, to }) => ({ label, to }));

  const { isMobile: subAbasMobile, activeItem: subAbaAtiva } = usePageHeaderTabs(todasSubAbas, {
    mobileQuery: FINANCEIRO_MOBILE_QUERY,
  });

  const emConfiguracoes = dentroDe(pathname, Paths.FINANCEIRO_CONFIGURACOES);
  const configuracoesLiberada = abas.some((aba) => aba.to === Paths.FINANCEIRO_CONFIGURACOES);
  const carregando = status === "idle" || status === "loading";

  let conteudo: FinanceiroConfiguracoesConteudo = "rota";
  if (emConfiguracoes) {
    if (carregando) conteudo = "carregando";
    else if (!configuracoesLiberada || todasSubAbas.length === 0) conteudo = "sem-permissao";
    else if (pathname.replace(/\/$/, "") === Paths.FINANCEIRO_CONFIGURACOES) {
      conteudo = "redirecionar";
    }
  }

  return {
    titulo: FINANCEIRO_TITLE,
    abas,
    abasLabel: FINANCEIRO_TABS_LABEL,
    mobileQuery: FINANCEIRO_MOBILE_QUERY,
    subAbas: emConfiguracoes && configuracoesLiberada ? todasSubAbas : [],
    subAbasLabel: FINANCEIRO_SUBABAS_LABEL,
    subAbasMobile,
    subAbaAtiva: subAbaAtiva?.to ?? null,
    irParaSubAba: (to) => navigate(to),
    conteudo,
    redirecionarPara: conteudo === "redirecionar" ? (todasSubAbas[0]?.to ?? null) : null,
  };
}
